export interface ArticleData {
  id: string;
  slug: string;
  title: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  heroImage: string;
  summary: string;
  content: string[];
  source: string;
  sourceUrl: string;
  publishDate: string;
  updateDate: string;
  viewCount: string;
  shareCount: string;
  tags: string[];
  author: string;
}

const baseArticles: Record<string, ArticleData> = {
  "wanghong-ta-fang-jingren-neimu": {
    id: "1",
    slug: "wanghong-ta-fang-jingren-neimu",
    title: "某千万粉网红塌房内幕曝光，背后金主浮出水面",
    category: "网红爆料",
    categorySlug: "wanghong-baoliao",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20social%20media%20influencer%20profile%20with%20red%20warning%20overlay%20on%20smartphone%20screen%20in%20warm%20amber%20and%20dark%20moody%20lighting%2C%20cinematic%20editorial%20style%2C%20high%20contrast%2C%20elegant%20minimal%20composition&width=800&height=600&seq=art-img-1&orientation=landscape",
    heroImage: "https://readdy.ai/api/search-image?query=Dramatic%20smartphone%20screen%20glowing%20in%20darkness%20showing%20breaking%20social%20media%20scandal%20alert%20with%20warm%20amber%20and%20red%20tones%2C%20cinematic%20product%20photography%2C%20elegant%20minimal%20composition%2C%20rich%20dark%20background%20with%20warm%20light%20rays%2C%20premium%20tech%20atmosphere&width=1200&height=700&seq=art-hero-1&orientation=landscape",
    summary: "一位拥有千万粉丝的知名网红近日被曝塌房，其背后金主身份也随之浮出水面。据知情人士透露，该网红长期以来依靠某神秘资本方包装打造人设，事件曝光后粉丝数量一夜暴跌200万。",
    content: [
      "近日，拥有超过1200万粉丝的知名美妆博主「小X」突然登上热搜，原因是有网友扒出其长期以来依靠某神秘资本方包装打造人设，所谓的「白手起家」故事实为精心编排的剧本。",
      "据爆料人提供的内部资料显示，该网红早在2019年便开始接受某资本的包装，从人设定位、内容策划到商业变现均有专业团队操盘。其视频中呈现的生活方式——住豪宅、开豪车、世界各地旅游——均由团队安排，并非真实生活。",
      "更令人震惊的是，该网红的「原创」美妆教程实际上也是团队策划的产物。知情人士透露，其发布的每一篇内容都经过至少三轮审核，确保符合资本方设定的品牌调性。所谓的产品推荐，实际上也是与品牌方提前签订的合作协议。",
      "事件曝光后，该网红的粉丝数量在一夜之间暴跌超过200万。评论区被「人设崩塌」、「被欺骗」等言论刷屏。多家与其合作的品牌方已紧急发布公告，宣布终止合作关系。",
      "目前，该网红的社交账号已设置为「仅关注可评论」模式，但负面评论仍在持续发酵。有法律专家指出，若该网红在推广过程中存在虚假宣传行为，或将面临消费者投诉及相关法律责任。",
    ],
    source: "51吃瓜独家调查",
    sourceUrl: "#",
    publishDate: "2026-07-07T08:30:00+08:00",
    updateDate: "2026-07-07T14:20:00+08:00",
    viewCount: "98.7万",
    shareCount: "12.3万",
    tags: ["网红塌房", "人设崩塌", "资本包装", "美妆博主"],
    author: "51吃瓜编辑部",
  },
  "mingxing-si-liao-bei-bao-guang": {
    id: "2",
    slug: "mingxing-si-liao-bei-bao-guang",
    title: "顶流明星私聊记录被曝光，内容令人大跌眼镜",
    category: "明星大瓜",
    categorySlug: "mingxing-dagua",
    imageUrl: "https://readdy.ai/api/search-image?query=Close%20up%20smartphone%20displaying%20blurred%20chat%20messages%20with%20redacted%20effect%20in%20warm%20amber%20and%20dark%20moody%20lighting%2C%20cinematic%20noir%20editorial%20style%2C%20high%20contrast&width=800&height=600&seq=art-img-2&orientation=landscape",
    heroImage: "https://readdy.ai/api/search-image?query=Dramatic%20smartphone%20floating%20in%20dark%20space%20displaying%20private%20chat%20messages%20with%20warm%20amber%20glow%2C%20cinematic%20product%20photography%2C%20elegant%20minimal%20composition%2C%20rich%20dark%20background%20with%20warm%20light%20rays&width=1200&height=700&seq=art-hero-2&orientation=landscape",
    summary: "某顶流男星与圈内人士的私聊记录被网友曝光，内容涉及多个敏感话题，引发全网热议。聊天记录显示其私下言论与公开形象反差极大。",
    content: [
      "近日，某顶流男星与圈内人士的私聊记录被匿名网友曝光，内容涉及对合作对象的不当评价、对粉丝的轻视态度以及对行业的负面看法，与其公开呈现的阳光正面形象形成鲜明对比。",
      "曝光的聊天记录时间跨度长达两年，涉及多个社交平台的私聊内容。其中最引发争议的是该男星在2025年底与某圈内好友的对话，其中不仅使用了大量粗俗语言，还对多位同行艺人进行了人身攻击。",
      "据爆料人透露，这些聊天记录来源于该男星旧手机的数据泄露。手机在维修过程中被不法分子拷贝了全部数据，随后流入了八卦爆料市场。目前，该男星团队已发布声明称将采取法律手段追究责任。",
      "事件曝光后，该男星代言的多个品牌方已紧急撤下相关宣传物料。某知名护肤品牌在其官方微博上删除了所有与该男星相关的内容。业内人士估计，此次事件可能导致其损失代言费超过5000万元。",
      "粉丝群体的反应呈现两极分化。部分忠实粉丝表示「私聊是个人隐私不应被公开」，而更多粉丝则表示「被欺骗多年，不会再支持」。该男星微博粉丝数量已从3200万跌至2800万。",
    ],
    source: "51吃瓜独家调查",
    sourceUrl: "#",
    publishDate: "2026-07-07T06:15:00+08:00",
    updateDate: "2026-07-07T16:30:00+08:00",
    viewCount: "86.3万",
    shareCount: "18.7万",
    tags: ["明星私聊", "人设反差", "数据泄露", "顶流男星"],
    author: "51吃瓜编辑部",
  },
  "zhibo-jian-chao-jia-xian-chang": {
    id: "3",
    slug: "zhibo-jian-chao-jia-xian-chang",
    title: "两大主播直播间互撕现场，粉丝集体倒戈",
    category: "直播风波",
    categorySlug: "zhibo-fengbo",
    imageUrl: "https://readdy.ai/api/search-image?query=Split%20screen%20streaming%20setup%20with%20dramatic%20red%20blue%20lighting%20contrast%2C%20gaming%20chair%20silhouettes%2C%20cinematic%20wide%20shot%2C%20editorial%20photography%20style%2C%20dark%20background%20with%20vibrant%20accent%20lighting&width=800&height=600&seq=art-img-3&orientation=landscape",
    heroImage: "https://readdy.ai/api/search-image?query=Dramatic%20dual%20streaming%20setup%20confrontation%20scene%20with%20two%20monitors%20facing%20each%20other%20in%20warm%20amber%20and%20dark%20moody%20lighting%2C%20cinematic%20editorial%20style%2C%20high%20contrast%2C%20battle%20atmosphere&width=1200&height=700&seq=art-hero-3&orientation=landscape",
    summary: "某平台两大头部主播在直播间公然互撕，互相揭露对方黑历史，粉丝集体倒戈站队，场面一度失控。",
    content: [
      "昨晚，某直播平台两大头部主播「阿强」和「老K」在各自的直播间同时开火，互相揭露对方的黑历史，场面一度失控。这场「直播互撕」吸引了超过500万观众在线观看，创造了该平台的历史记录。",
      "事件的起因是老K在直播中暗示阿强的带货数据存在造假行为。阿强随即在自己的直播间进行了强硬回应，不仅否认了数据造假，还反手爆料老K曾在2024年因偷税漏税被税务机关约谈。",
      "双方你来我往，爆料内容不断升级。从商业竞争到个人隐私，从粉丝群体攻击到平台规则质疑，两小时的互撕大战让吃瓜群众大呼过瘾。据不完全统计，期间双方直播间累计收到弹幕超过2000万条。",
      "粉丝群体的反应也呈现出明显的站队现象。阿强的粉丝纷纷在老K的直播间刷「骗子」，而老K的粉丝则在阿强的直播间刷「逃税犯」。平台运营方多次尝试介入调停，但双方均拒绝下播。",
      "事件发酵后，平台方发布公告，对两位主播均作出禁播7天的处罚决定。业内分析认为，这场互撕虽然为平台带来了巨大的流量，但也暴露了直播行业内部恶性竞争的严重问题。",
    ],
    source: "51吃瓜直播观察",
    sourceUrl: "#",
    publishDate: "2026-07-07T10:00:00+08:00",
    updateDate: "2026-07-07T12:00:00+08:00",
    viewCount: "72.5万",
    shareCount: "9.8万",
    tags: ["直播互撕", "头部主播", "数据造假", "偷税漏税"],
    author: "51吃瓜编辑部",
  },
  "jintian-chigua-dasai": {
    id: "4",
    slug: "jintian-chigua-dasai",
    title: "今日吃瓜大赛：谁家的瓜最甜？",
    category: "每日大赛",
    categorySlug: "meiri-dasai",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20watermelon%20cross%20section%20with%20juicy%20red%20flesh%20in%20warm%20amber%20and%20dark%20moody%20lighting%2C%20cinematic%20editorial%20food%20photography%2C%20high%20contrast%2C%20elegant%20minimal%20composition&width=800&height=600&seq=art-img-4&orientation=landscape",
    heroImage: "https://readdy.ai/api/search-image?query=Dramatic%20watermelon%20arrangement%20with%20multiple%20slices%20and%20juice%20dripping%20in%20warm%20amber%20and%20dark%20moody%20lighting%2C%20cinematic%20editorial%20food%20photography%2C%20high%20contrast%2C%20elegant%20minimal%20composition&width=1200&height=700&seq=art-hero-4&orientation=landscape",
    summary: "今日吃瓜大赛正式开始！我们精选了今日全网最热门的10条爆料，快来投票选出你最爱的瓜。排名实时更新，最终赢家将获得51吃瓜年度吃瓜王称号！",
    content: [
      "欢迎来到51吃瓜网每日吃瓜大赛！今天，我们精选了今日全网最热门的10条爆料，邀请各位吃瓜群众一起投票选出「今日最甜瓜」。",
      "今日参赛的瓜田选手包括：网红塌房系列（小X人设崩塌、美食博主反差行为）、明星大瓜系列（顶流男星私聊曝光、某歌手假唱风波）、直播风波系列（两大主播互撕、游戏主播封号内幕）以及更多新鲜爆料。",
      "投票规则：每位用户可投3票，分别投给认为最炸裂、最反转、最意外的三条爆料。投票截止时间为今晚24:00，届时我们将公布今日吃瓜大赛的最终排名。",
      "截至目前，「顶流男星私聊曝光」以45%的得票率遥遥领先，「两大主播互撕」以32%紧随其后。但网红塌房系列正在快速追赶，比赛结果仍存在变数！",
      "除了投票之外，我们还开设了「吃瓜评论区」，欢迎各位吃瓜群众分享自己的看法。最精彩的评论将获得51吃瓜限定周边礼包！",
    ],
    source: "51吃瓜编辑部",
    sourceUrl: "#",
    publishDate: "2026-07-07T09:00:00+08:00",
    updateDate: "2026-07-07T20:00:00+08:00",
    viewCount: "112.3万",
    shareCount: "25.6万",
    tags: ["每日大赛", "吃瓜投票", "爆料排行", "互动活动"],
    author: "51吃瓜编辑部",
  },
};

export function getArticleBySlug(slug: string): ArticleData {
  if (baseArticles[slug]) {
    return baseArticles[slug];
  }

  const defaultArticle: ArticleData = {
    id: "0",
    slug,
    title: "精彩爆料加载中",
    category: "热门爆料",
    categorySlug: "wanghong-baoliao",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20mystery%20investigation%20scene%20with%20magnifying%20glass%20and%20documents%20in%20warm%20amber%20and%20dark%20moody%20lighting%2C%20cinematic%20editorial%20style%2C%20high%20contrast%2C%20elegant%20minimal%20composition&width=800&height=600&seq=art-default&orientation=landscape",
    heroImage: "https://readdy.ai/api/search-image?query=Dramatic%20mystery%20investigation%20scene%20with%20magnifying%20glass%20and%20documents%20in%20warm%20amber%20and%20dark%20moody%20lighting%2C%20cinematic%20editorial%20style%2C%20high%20contrast%2C%20elegant%20minimal%20composition&width=1200&height=700&seq=art-hero-default&orientation=landscape",
    summary: "这条爆料正在整理中，51吃瓜网调查团队正在深入核实相关证据，预计将于24小时内发布完整报道。",
    content: [
      "51吃瓜网调查团队正在深入核实相关爆料信息。",
      "为了确保报道的准确性和公正性，我们的团队正在与多方信源进行交叉验证。",
      "预计在24小时内，我们将发布包含完整证据链和事件时间线的深度报道。",
      "请持续关注51吃瓜网，第一时间获取最新进展。",
    ],
    source: "51吃瓜编辑部",
    sourceUrl: "#",
    publishDate: "2026-07-07T00:00:00+08:00",
    updateDate: "2026-07-07T00:00:00+08:00",
    viewCount: "0",
    shareCount: "0",
    tags: ["爆料追踪", "调查中"],
    author: "51吃瓜编辑部",
  };

  return defaultArticle;
}

export function getRelatedArticles(currentSlug: string, categorySlug: string) {
  const allArticles = Object.values(baseArticles).filter(a => a.slug !== currentSlug);
  const sameCategory = allArticles.filter(a => a.categorySlug === categorySlug).slice(0, 2);
  const others = allArticles.filter(a => a.categorySlug !== categorySlug).slice(0, 1);
  return [...sameCategory, ...others];
}